import { Page } from '@/core/architecture'

import { ConsoleCampaignsTemplate } from './template'
import { useViewModel } from './viewModel'

export const ConsoleCampaigns: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ConsoleCampaignsTemplate state={state} onFetchMore={actions.onFetchMore} />
  )
}
